import React, { Component }  from 'react'
import StyleSheet            from 'styles'
import PropTypes             from 'prop-types'

import { NominationsList }   from 'containers/nominations'
import * as Allocations      from '.'

export class BookBuild extends Component{

  static propTypes = {
    dealSheet: PropTypes.object.isRequired
  }

  dependenciesMet(){
    return true
  }

  render = () =>
    <div className={styles.showContainer}>
      <Allocations.List dealSheet={this.props.dealSheet}/>
      <NominationsList dealSheet={this.props.dealSheet}/>
    </div>
}


const styles = StyleSheet({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'flex-start',
    flexDirection: 'row',
    flexWrap: 'wrap',
    flex: 1,
  },
  showContainer: {
    flex: 1,
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
})


export default BookBuild